import { cacheExchange, createClient, fetchExchange } from 'urql';
import { DEX_INFO } from '../config/pools';
import { validateEnvironment } from '../utils/envValidation';

// Validate environment variables on import
try {
  validateEnvironment();
} catch (error) {
  console.error('Environment validation failed:', error);
  // Continue with app loading even if validation fails
}

const API_KEY = process.env.REACT_APP_THE_GRAPH_API_KEY!;

// Create individual clients for each DEX (matching Python approach exactly)
export const uniswapV3Client = createClient({
  url: `https://gateway.thegraph.com/api/${API_KEY}/subgraphs/id/${DEX_INFO.uniswap_v3.subgraphId}`,
  fetchOptions: {
    headers: {
      Authorization: `Bearer ${API_KEY}`,
    },
  },
  exchanges: [cacheExchange, fetchExchange],
});

export const pancakeswapV3Client = createClient({
  url: `https://gateway.thegraph.com/api/${API_KEY}/subgraphs/id/${DEX_INFO.pancakeswap_v3.subgraphId}`,
  fetchOptions: {
    headers: {
      Authorization: `Bearer ${API_KEY}`,
    },
  },
  exchanges: [cacheExchange, fetchExchange],
});

export const uniswapV4Client = createClient({
  url: `https://gateway.thegraph.com/api/${API_KEY}/subgraphs/id/${DEX_INFO.uniswap_v4.subgraphId}`,
  fetchOptions: {
    headers: {
      Authorization: `Bearer ${API_KEY}`,
    },
  },
  exchanges: [cacheExchange, fetchExchange],
});

export const sushiswapV3Client = createClient({
  url: `https://gateway.thegraph.com/api/${API_KEY}/subgraphs/id/${DEX_INFO.sushiswap_v3.subgraphId}`,
  fetchOptions: {
    headers: {
      Authorization: `Bearer ${API_KEY}`,
    },
  },
  exchanges: [cacheExchange, fetchExchange],
});

// Helper function to get the correct client for a DEX
export const getClientForDEX = (dex: string) => {
  switch (dex) {
    case 'uniswap_v3':
      return uniswapV3Client;
    case 'pancakeswap_v3':
      return pancakeswapV3Client;
    case 'uniswap_v4':
      return uniswapV4Client;
    case 'sushiswap_v3':
      return sushiswapV3Client;
    default:
      throw new Error(`Unknown DEX: ${dex}`);
  }
};

// Helper function to get the correct URL for a DEX (for fetch-based approach)
export const getUrlForDEX = (dex: string) => {
  switch (dex) {
    case 'uniswap_v3':
      return `https://gateway.thegraph.com/api/${API_KEY}/subgraphs/id/${DEX_INFO.uniswap_v3.subgraphId}`;
    case 'pancakeswap_v3':
      return `https://gateway.thegraph.com/api/${API_KEY}/subgraphs/id/${DEX_INFO.pancakeswap_v3.subgraphId}`;
    case 'uniswap_v4':
      return `https://gateway.thegraph.com/api/${API_KEY}/subgraphs/id/${DEX_INFO.uniswap_v4.subgraphId}`;
    case 'sushiswap_v3':
      return `https://gateway.thegraph.com/api/${API_KEY}/subgraphs/id/${DEX_INFO.sushiswap_v3.subgraphId}`;
    default:
      throw new Error(`Unknown DEX: ${dex}`);
  }
};

// Test function to verify API key is working
export const testGraphQLConnection = async () => {
  try {
    const testQuery = `
      query {
        _meta {
          hasIndexingErrors
          block {
            number
            hash
          }
        }
      }
    `;
    
    const result = await uniswapV3Client.query(testQuery, {}).toPromise();
    return {
      success: true,
      data: result.data,
      error: result.error
    };
  } catch (error) {
    return {
      success: false,
      data: null,
      error: error as Error
    };
  }
};
